import * as React from "react";
import { cn } from "~/lib/utils";
import { Label as LabelComponent } from "~/components/ui/label";
import { FormLabel as FormLabelComponent } from "~/components/ui/form";

type LabelProps = React.ComponentProps<typeof LabelComponent>;
type FormLabelProps = React.ComponentProps<typeof FormLabelComponent>;

const labelClassName = cn(
  //
  "leading-normal"
);

export function FormLabel({ className, ...props }: FormLabelProps) {
  return <FormLabelComponent className={cn(labelClassName, className)} {...props} />;
}

export function Label({ className, ...props }: LabelProps) {
  return <LabelComponent className={cn(labelClassName, className)} {...props} />;
}
